module.exports = __webpack_public_path__ + "static/media/work-img9.31f28ddf.jpg";